<script setup lang="ts">
import { computed } from "vue";
import CmsDataProvider, { CMS_DATA_ID } from "@/providers/cms.provider";

type ActivityType = "bewegen" | "beleven" | "spelen";

const props = defineProps<{
	active: ActivityType;
}>();

const emit = defineEmits<{
	(e: "change", activityType: ActivityType): void;
}>();

const cmsData = CmsDataProvider.get<{
	hideBewegenFilters: boolean,
	hideBelevenFilters: boolean,
	hideSpelenFilters: boolean
}>(CMS_DATA_ID.INTERACTIEVE_KAART);

const activities = computed(() => {
	const items = [];

	if (!cmsData.hideBewegenFilters) {
		items.push({ key: "bewegen" as ActivityType, label: "Bewegen" });
	}

	if (!cmsData.hideBelevenFilters) {
		items.push({ key: "beleven" as ActivityType, label: "Beleven" });
	}

	if (!cmsData.hideSpelenFilters) {
		items.push({ key: "spelen" as ActivityType, label: "Spelen" });
	}

	return items;
});

const handleChange = (activityType: ActivityType): void => {
	if (activityType !== props.active) {
		emit("change", activityType);
	}
};
</script>

<template>
	<div class="search-swapper">
		<button
			v-for="activity in activities"
			:key="activity.key"
			:class="['btn', 'btn-sm', { 'btn-primary': active === activity.key }]"
			@click="handleChange(activity.key)"
		>
			{{ activity.label }}
		</button>
	</div>
</template>
